import { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import { CheckCircle2 } from 'lucide-react';

import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

// Reflet passif du tap parent sur l'écran de suivi live (parent_confirmed_at) —
// signal purement observationnel, jamais un pointage GPS/chauffeur. Utilisé par
// frontHistory.jsx (detail-row trajet) et frontGpsSuivi.jsx (suivi temps réel).
//
// `title` HTML natif ne déclenche pas de façon fiable au survol et n'existe pas
// au toucher (tablette) — Tooltip Radix ici, en `open` contrôlé : hover marche
// nativement côté desktop, `onClick` bascule l'ouverture pour couvrir le tap
// tablette (Radix n'ouvre pas les tooltips au tap par conception).
export default function ParentConfirmedTick({ confirmedAt, size = 12 }) {
  const [open, setOpen] = useState(false);

  if (!confirmedAt) return null;

  const label = `Confirmé par le parent à ${format(parseISO(confirmedAt), 'HH:mm', { locale: fr })}`;

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={label}
          className="inline-flex shrink-0 items-center justify-center p-0.5 -m-0.5"
          onClick={(e) => {
            e.stopPropagation();
            setOpen((o) => !o);
          }}
        >
          <CheckCircle2 size={size} className="text-green-600 shrink-0" />
        </button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
